import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilter, faAngleDown } from '@fortawesome/pro-solid-svg-icons';

import { toggleMobileFilters } from "../store/actions/ui";
export class MobileFilterTopBar extends React.Component {
  static propTypes = {
    contactRoles: PropTypes.array.isRequired,
    selectedRoles: PropTypes.array.isRequired,
    tags: PropTypes.array.isRequired,
    onDisplayFilters: PropTypes.func.isRequired
  };

  render() {
    const { selectedRoles, contactRoles, tags, onDisplayFilters } = this.props;

    const appliedFilters = [];
    selectedRoles.forEach((selectedRole) => {
      const role = contactRoles.find(role => role.value === selectedRole);
      appliedFilters.push(role.label);
    });
    tags.forEach(tag => appliedFilters.push(tag));

    return (
      <div className="visible-xs visible-sm">
        <div className="filters-row mobile-filters-row">
          {appliedFilters.length > 0 ?
            <button className="filters-text" onClick={onDisplayFilters}>
              <div className="filters-count">{appliedFilters.length}</div>
              <strong>Filters:</strong>
              <span className="applied-filters-text">{appliedFilters.join(", ")}</span>
            </button>
            : <button className="filters-text" onClick={onDisplayFilters}>
              <FontAwesomeIcon
                className="right-buffer-sm"
                icon={faFilter}
              />
              Filters
              <FontAwesomeIcon
                className="left-buffer-sm"
                icon={faAngleDown}
              />
            </button>
          }
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  contactRoles: state.static.contactRoles,
  selectedRoles: state.query.roles,
  tags: state.query.tags
});

const mapDispatchToProps = {
  onDisplayFilters: toggleMobileFilters
};

export default connect(mapStateToProps, mapDispatchToProps)(MobileFilterTopBar);
